<template>
  <div>
    
        <div class="sex_header">
          <chart
            ref="chart2"
            :options="pieOrgOptions"
            :auto-resize="true"
          ></chart>
          <chart
            ref="chart3"
            :options="piesOrgOptions"
            :auto-resize="true"
          ></chart>
        </div>
        <div class="box_border">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="name" label="已看家长姓名">
            </el-table-column>
            <el-table-column prop="time" label="观看时间"> </el-table-column>
          </el-table>
        </div>
     
  </div>
</template>

<script>
import { GetYuanChartDataByYearGrade } from "../../api/api";
export default {
  data() {
    return {
      queryinfo: [],
      activeName: "first",
      orgOptions: {},
      pieOrgOptions: {},
      piesOrgOptions: {},
      tableData: [
        
      ],
    };
  },
  created() {
    this.queryinfo = this.$route.query;
    GetYuanChartDataByYearGrade(this.queryinfo).then((res) => {
      if (res.data.response.education.length > 0) {
this.tableData=res.data.response.nametime;
        this.$nextTick(() => {
          this.piesOrgOptions = {
            title: {
              left: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              // orient: 'vertical',
              // top: 'middle',
              bottom: 10,
              left: "center",
              data: ["高中/中职校", "大专", "本科", "初中及以下", "研究生"],
            },
            series: [
              {
                type: "pie",
                radius: "65%",
                center: ["50%", "50%"],
                selectedMode: "single",
                data: res.data.response.education,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
          //   饼图
          this.pieOrgOptions = {
            title: {
              left: "center",
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              // orient: 'vertical',
              // top: 'middle',
              bottom: 10,
              left: "center",
              data: ["男", "女"],
            },
            series: [
              {
                type: "pie",
                radius: "65%",
                center: ["50%", "50%"],
                selectedMode: "single",
                data: res.data.response.sex,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
        });
      }
    });
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 点击事件
    onClick(params) {
      console.log("点击了柱状图", params.dataIndex);
    },
  },
  mounted() {},
};
</script>

<style scoped>
.box_border {
  width: 500px;
  margin: 0 auto;
}
.class_header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sex_header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.echarts_demo {
  width: 800px;
}
</style>